// The session-identity cookie klue writes on every sign-in and sign-out
// (ApplicationController#write_identity_cookie): "companyId.timestamp", or "0.timestamp" once
// signed out. useSessionIdentityChange compares it on tab focus to notice a session change.
//
// klue moved it to a __Secure- name (ASVS V3.3.1). The old name is still read when the new one is
// absent, so a browser that hasn't signed in or out since keeps working until it does.
export const IDENTITY_COOKIE = '__Secure-_klue_identity';
export const LEGACY_IDENTITY_COOKIE = '_klue_identity';

function readCookie(name: string): string | null {
  const pair = document.cookie
    .split('; ')
    .find((cookie) => cookie.startsWith(`${name}=`));

  return pair ? decodeURIComponent(pair.slice(name.length + 1)) : null;
}

export function readIdentityCookie(): string | null {
  return readCookie(IDENTITY_COOKIE) ?? readCookie(LEGACY_IDENTITY_COOKIE);
}
